import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IHeaderTitle {
  title: string;
}

export const HeaderTitle = ({ title }: IHeaderTitle) => {
  const dictionary = Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby];

  const isDesktop = useIsDesktop();
  return (
    <Stack width={'100%'}>
      <Typography
        variant='h2'
        component={'h1'}
        tabIndex={0}
        sx={{
          fontWeight: 700,
          fontSize: '28px',
          mt: 2,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant='body3'
        tabIndex={0}
        sx={{
          mt: isDesktop ? 2 : 1,
        }}
      >
        {dictionary.createOrder.subtitle}
      </Typography>
    </Stack>
  );
};
